import { render } from "./TheScrollButton.vue?vue&type=template&id=442d2cb8&scoped=true"
import script from "./TheScrollButton.vue?vue&type=script&lang=js"
export * from "./TheScrollButton.vue?vue&type=script&lang=js"

import "./TheScrollButton.vue?vue&type=style&index=0&id=442d2cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442d2cb8"]])

export default __exports__